export default __webpack_public_path__ + "static/media/krakenimages.0869b7d4.png";